import { fetch, fetchOk } from '@atlassian/mpac-fetch-wrapper';
import { makeAppFetchError } from '@atlassian/mpac-spi';
import { log } from '@atlassian/mpac-utils';
import queryString from 'query-string';
import { calculateRetries, getUPMCredentials } from './connect/Util';
const defaultOptions = upmBaseUrl => ({
  credentials: getUPMCredentials(upmBaseUrl)
});
const getInstallPermissionsUrl = (upmBaseUrl, appKey) => "".concat(upmBaseUrl, "/rest/plugins/1.0/apps/install-subscribe/permission?addonKey=").concat(appKey);
const getInstalledPluginUrl = (upmBaseUrl, appKey) => "".concat(upmBaseUrl, "/rest/plugins/1.0/").concat(appKey, "-key");
const getInstalledMarketplacePluginUrl = (upmBaseUrl, appKey) => "".concat(upmBaseUrl, "/rest/plugins/1.0/").concat(appKey, "/marketplace");
const getAvailablePluginUrl = (upmBaseUrl, appKey, query) => "".concat(upmBaseUrl, "/rest/plugins/1.0/available/").concat(appKey, "-key").concat(query ? "?".concat(query) : '');
const getAllInstalledMarketplacePluginsUrl = upmBaseUrl => "".concat(upmBaseUrl, "/rest/plugins/1.0/installed-marketplace");
const getHostStatusUrl = upmBaseUrl => "".concat(upmBaseUrl, "/rest/plugins/1.0/host-status");
const getAllInstalledPluginsUrl = upmBaseUrl => "".concat(upmBaseUrl, "/rest/plugins/1.0/");
export async function getInstalledAppFromUpm(upmBaseUrl, appKey) {
  try {
    const result = await fetchOk(getInstalledPluginUrl(upmBaseUrl, appKey), defaultOptions(upmBaseUrl));
    const response = await result.json();
    return {
      links: {
        postInstall: response.links['post-install'],
        configure: response.links.configure,
        manage: response.links.manage
      },
      key: response.key
    };
  } catch (error) {
    const InstalledAppFromUPMError = makeAppFetchError('InstalledAppFromUPMError');
    throw new InstalledAppFromUPMError({
      source: error,
      appKey
    });
  }
}
export async function getInstallPermissions(upmBaseUrl, appKey) {
  const response = await fetch(getInstallPermissionsUrl(upmBaseUrl, appKey), defaultOptions(upmBaseUrl));
  if (response.status >= 200 && response.status <= 299) {
    return Promise.resolve(true);
  } else if (response.status === 401 || response.status === 403) {
    return Promise.resolve(false);
  } else {
    return Promise.reject("".concat(response.status, ": ").concat(response.statusText));
  }
}
const fetchInstalledMarketplacePluginFromUpm = (upmBaseUrl, appKey, options) => fetchOk(getInstalledMarketplacePluginUrl(upmBaseUrl, appKey), options).then(response => response.json());
export const getOptionsForFetchInstalledMarketplacePluginFromUpm = (upmBaseUrl, shouldRetryForLicenseDetails) => {
  const pollAfter = 3000;
  const optionsForRetry = {
    retries: calculateRetries(0.16, pollAfter),
    retryDelay: pollAfter,
    credentials: getUPMCredentials(upmBaseUrl),
    accept: response => response.json().then(bodyJSON => {
      if (bodyJSON.licenseDetails === undefined) {
        log.info('upmApi', "Retries failed for fetching license details of the app : ".concat(bodyJSON.appKey, " "));
        throw new Error('Error in fetching license details');
      }
    })
  };
  const optionsForNoRetry = defaultOptions(upmBaseUrl);
  if (shouldRetryForLicenseDetails) return optionsForRetry;else return optionsForNoRetry;
};
export const getInstalledMarketplacePluginFromUpm = async (upmBaseUrl, appKey, shouldRetryForLicenseDetails) => {
  try {
    const options = getOptionsForFetchInstalledMarketplacePluginFromUpm(upmBaseUrl, shouldRetryForLicenseDetails);
    const result = await fetchInstalledMarketplacePluginFromUpm(upmBaseUrl, appKey, options);
    return result;
  } catch (error) {
    const InstalledMarketplacePluginUPMError = makeAppFetchError('InstalledMarketplacePluginUPMError');
    throw new InstalledMarketplacePluginUPMError({
      source: error,
      appKey
    });
  }
};
export const getAvailableAppFromUpm = (upmBaseUrl, appKey, hostCmtEnabled) => fetchOk(getAvailablePluginUrl(upmBaseUrl, appKey, queryString.stringify({
  hostCmtEnabled
})), defaultOptions(upmBaseUrl)).then(r => r.json());
export const getInstalledMarketplaceFromUpm = upmBaseUrl => fetchOk(getAllInstalledMarketplacePluginsUrl(upmBaseUrl), defaultOptions(upmBaseUrl)).then(r => r.json());
export async function getAllInstalledAppsFromUpm(upmBaseUrl) {
  const result = await fetchOk(getAllInstalledPluginsUrl(upmBaseUrl), defaultOptions(upmBaseUrl));
  const response = await result.json();
  return response.plugins.filter(app => (app.userInstalled || app.usesLicensing) && app.name !== 'Embedded Marketplace').map(app => ({
    links: {
      postInstall: app.links['post-install'],
      configure: app.links.configure,
      manage: app.links.manage
    },
    key: app.key
  }));
}
export const getHostStatusFromUpm = upmBaseUrl => fetchOk(getHostStatusUrl(upmBaseUrl), defaultOptions(upmBaseUrl)).then(r => r.json());